import React, { useState } from 'react'
import MultiSelect from '../../../../components/common/MultiSelect'
import PageHeading from '../../../../components/common/PageHeading'
import { guestfilterinboxby } from '../../../../data/guestcards'
import { sortVacanciesList } from '../../../../utils/Util'
import { Card, Checkbox, Form, Select, Input, Space, Row, Col, Button } from 'antd'
import { PrinterFilled, MailFilled } from '@ant-design/icons';
import RightBar from '../../../../components/common/RightBar'
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod'

const { TextArea } = Input;

const createVacanciesListRightBar = [
    RightBarMethod("", "t1", "", [
    ]),
  ];

function CreateVacanciesList() {

    const [contactInfoNotes, setContactInfoNotes] = useState(true);
    const [propertyPictures, setPropertyPictures] = useState(true);
    const [applicationFee, setApplicationFee] = useState(true);
    const [marketingDescription, setMarketingDescription] = useState(true);
    const [deposits, setDeposits] = useState(true);
    const [amenitiesList, setAmenitiesList] = useState(true);
    const [availableDate, setAvailableDate] = useState(true);
    const [squareFeet, setSquareFeet] = useState(true);

    return (
        <>
            <PageHeading heading="Create Vacancies List" />

            <Form
                name="basic"
                labelCol={{ span: 7 }}
                initialValues={{ remember: true }}
                autoComplete="off"
                className="form-container"
                colon={false}>

                <Card>

                    <Form.Item
                        name='properties'
                        label="Properties"
                        wrapperCol={{ span: 8 }}>

                        <MultiSelect
                            options={guestfilterinboxby}
                            placeholder="Select..."
                            className="filter-select"
                        />

                    </Form.Item>

                    <Form.Item
                        name='sortBy'
                        label="Sort By"
                        wrapperCol={{ span: 8 }}>

                        <Select options={sortVacanciesList} />


                    </Form.Item>

                    <Form.Item
                        label=" "
                        wrapperCol={{ span: 8 }}>

                        <p>Your vacancy list will include the units' <b>Marketing Title, Address, Rent</b> and <b>Bed/Bath</b> count.
                            Additionally, you may include:</p>


                    </Form.Item>

                    <Form.Item
                        label=" ">

                        <Space direction='vertical' style={{ width: '100%' }}>
                            <Checkbox checked={contactInfoNotes} onChange={() => setContactInfoNotes(!contactInfoNotes)}>Contact Information & Notes</Checkbox>
                            <TextArea rows={4} defaultValue="PO Box 1451, Bethany, OK 73008
                            (405) 283-6521" disabled={!contactInfoNotes} />
                        </Space>

                    </Form.Item>


                    <Form.Item
                        label=" ">

                        <Row style={{ marginBottom: 8 }}>
                            <Col span={12}>

                                <Space direction='vertical' style={{ width: '100%' }}>

                                    <Checkbox checked={propertyPictures} onChange={() => setPropertyPictures(!propertyPictures)}>Property Picture</Checkbox>
                                    <Checkbox checked={marketingDescription} onChange={() => setMarketingDescription(!marketingDescription)}>Marketing Description</Checkbox>
                                    <Checkbox checked={amenitiesList} onChange={() => setAmenitiesList(!amenitiesList)}>Amenities List</Checkbox>
                                    <Checkbox checked={squareFeet} onChange={() => setSquareFeet(!squareFeet)}>Square Feet</Checkbox>
                                </Space>
                            </Col>
                            <Col span={12}>

                                <Space direction='vertical' style={{ width: '100%' }}>

                                    <Checkbox checked={applicationFee} onChange={() => setApplicationFee(!applicationFee)}>Application Fee</Checkbox>
                                    <Checkbox checked={deposits} onChange={() => setDeposits(!deposits)}>Deposit</Checkbox>
                                    <Checkbox checked={availableDate} onChange={() => setAvailableDate(!availableDate)}>Availabe Date</Checkbox>

                                </Space>
                            </Col>
                        </Row>


                    </Form.Item>

                </Card>

            </Form>


            <div className="form-action page-actions-container" style={{ marginTop: 22 }}>
                <Button icon={<PrinterFilled />}>Print</Button>
                <Button icon={<MailFilled />}>Email</Button>
            </div>

            <div className="RightSidebar">
                <RightBar RightBarData={createVacanciesListRightBar} />
            </div>

        </>
    )
}

export default CreateVacanciesList